import { startLoader, stopLoader } from "../libs/utils";
import { getWebhookDetails } from "../services/user";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";


function flattenObject(obj, prefix = '', res = {}) {
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    const value = obj[key];
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      flattenObject(value, newKey, res);
    } else {
      res[newKey] = value;
    }
  }
  return res;
}

function renderObjectAsTable(data) {
  function escapeHtml(str) {
    if (typeof str !== "string") return str;
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function formatDate(timestamp) {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp));
    if (isNaN(date.getTime())) return timestamp;
    // Format: YYYY-MM-DD HH:mm:ss
    return date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, '0') + "-" +
      String(date.getDate()).padStart(2, '0') + " " +
      String(date.getHours()).padStart(2, '0') + ":" +
      String(date.getMinutes()).padStart(2, '0') + ":" +
      String(date.getSeconds()).padStart(2, '0');
  }

  if (Array.isArray(data)) {
    if (data.length === 0) return "<div>No Data</div>";
    if (typeof data[0] === "object" && data[0] !== null) {
      // Array of objects
      return data
        .map(
          (item, idx) => `
        <div style="margin-bottom:16px; border:1px solid #ccc; padding:10px;">
          <div style="font-weight:bold; margin-bottom:8px;">Item ${idx + 1}</div>
          ${renderObjectAsTable(item)}
        </div>
      `
        )
        .join("");
    } else {
      // Array of primitives
      return `
        <table border="1" style="border-collapse:collapse; width:100%;">
          <tbody>
            ${data.map(item => `<tr><td>${escapeHtml(String(item))}</td></tr>`).join("")}
          </tbody>
        </table>
      `;
    }
  } else if (typeof data === "object" && data !== null) {
    // FLATTEN the object before rendering
    const flatData = flattenObject(data);
    const keys = Object.keys(flatData);
    if (keys.length === 0) return "<div>{}</div>";
    return `
      <table border="1" style="border-collapse:collapse; width:100%; margin-bottom:10px;">
        <tbody>
          ${keys
            .map(
              key => `
            <tr>
              <th style="text-align:left; vertical-align:top; width: 200px; padding:8px; background:#f5f5f5;">${escapeHtml(key.split('.').pop())}</th>
              <td style="padding:8px;">${key === 'createdDate' && typeof flatData[key] === 'number' ? formatDate(flatData[key]) : escapeHtml(String(flatData[key]))}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
    `;
  } else {
    // Primitive value
    return `<span>${escapeHtml(String(data))}</span>`;
  }
}

 
  const handleWebhookDetails = async (documentId) => {
    startLoader();
    const result = await getWebhookDetails(documentId);
    stopLoader();
    if (result.success) {
      let details = result.webhook_details;
      // If details is a string, try to parse as JSON
      if (typeof details === "string") {
        try {
          details = JSON.parse(details);
        } catch (e) {
          // If parsing fails, keep as string
        }
      }
      // If details is an array, parse webhook_response for each item
      if (Array.isArray(details)) {
        details = details.map(item => {
          if (item && typeof item.webhook_response === "string") {
            try {
              return {
                ...item,
                webhook_response: JSON.parse(item.webhook_response)
              };
            } catch (e) {
              // If parsing fails, keep as string
              return item;
            }
          }
          return item;
        });
      }
      Swal.fire({
        title: "Webhook Details",
        html: renderObjectAsTable(details),
        icon: "info",
        confirmButtonText: "Ok",
        width: 1000,
        customClass: { htmlContainer: "swal2-overflow-table" }
      });
    } else {
      Swal.fire({
        title: "Oops",
        text: result.error?.data?.error?.message || "Something went wrong",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  export default handleWebhookDetails;